<template>
    <div class="container min-h-screen bg-[#11111b] text-white flex flex-col">
        <Header />
        <main id="hero-section"
            class="p-4 sm:p-6 bg-[url('@/assets/images/background.png')] bg-cover bg-center min-h-screen flex items-center justify-center">
            <div class="w-full max-w-4xl px-4 flex flex-col items-center justify-center text-center z-10">
                <h1 class="home-page text-[2.5rem] sm:text-5xl md:text-6xl lg:text-7xl font-bold text-transparent">
                    {{ '404' }}
                </h1>
                <p class="text-base sm:text-lg md:text-xl mt-2 sm:mt-4 leading-tight text-white">
                    Page Not Found
                </p>
            </div>
        </main>
        <ClientFooter />
    </div>
</template>

<script setup>
import ClientFooter from '@/components/ClientFooter.vue';
import Header from '@/components/Header.vue';


</script>

<style scoped>
.container {
    width: 100%;
    max-width: none;
    min-height: 100vh;
}




.home-page {
    text-align: center;
    z-index: 5;
    color: transparent;
    -webkit-text-stroke: 1px #fff;
    background: url(/src/assets/images/back.png);
    background-size: cover;
    background-position: 0 0;
    -webkit-background-clip: text;
    background-clip: text;
    animation: back 20s linear infinite;
}

.auto-type-safe {
    display: inline-block;
    white-space: nowrap;
    vertical-align: middle;
}

@media (max-width: 640px) {
    .home-page {
        font-size: 4rem;
        -webkit-text-stroke: 0.5px #fff;
        background-size: 200%;
        line-height: 1.2;
    }
}

@media (min-width: 641px) and (max-width: 768px) {
    .home-page {
        font-size: 5rem;
        -webkit-text-stroke: 0.5px #fff;
        background-size: 150%;
        line-height: 1.2;
    }
}

@keyframes back {
    100% {
        background-position: 2000px 0;
    }
}
</style>